// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingSSizeWide": "20",
	"headingSSizeNarrow": "16",
	"headingSFamily": "\"JetSansDigital\"",
	"headingSWeight": "800",
	"headingSLetterSpacing": "0",
	"headingMSizeWide": "24",
	"headingMSizeNarrow": "20",
	"headingMFamily": "\"JetSansDigital\"",
	"headingMWeight": "800",
	"headingMLetterSpacing": "0g",
	"headingLSizeWide": "28",
	"headingLSizeNarrow": "24",
	"headingLFamily": "\"JetSansDigital\"",
	"headingLWeight": "800",
	"headingLLetterSpacing": "0",
	"headingXlSizeWide": "32",
	"headingXlSizeNarrow": "28",
	"headingXlFamily": "\"JetSansDigital\"",
	"headingXlWeight": "800",
	"headingXlLetterSpacing": "0",
	"headingXxlSizeWide": "48",
	"headingXxlSizeNarrow": "32",
	"headingXxlFamily": "\"JetSansDigital\"",
	"headingXxlWeight": "800",
	"headingXxlLetterSpacing": "0",
	"SubheadingSSizeWide": "20",
	"SubheadingSSizeNarrow": "16",
	"SubheadingSFamily": "\"JetSansDigital\"",
	"SubheadingSWeight": "400",
	"SubheadingSLetterSpacing": "0",
	"SubheadingLSizeWide": "24",
	"SubheadingLSizeNarrow": "20",
	"SubheadingLFamily": "\"JetSansDigital\"",
	"SubheadingLWeight": "400",
	"SubheadingLLetterSpacing": "0",
	"buttonXsSize": "14",
	"buttonXsFamily": "\"JetSansDigital\"",
	"buttonXsWeight": "700",
	"buttonXsLetterSpacing": "0",
	"buttonSSize": "16",
	"buttonSFamily": "\"JetSansDigital\"",
	"buttonSWeight": "700",
	"buttonSLetterSpacing": "0",
	"buttonMSize": "20",
	"buttonMFamily": "\"JetSansDigital\"",
	"buttonMWeight": "700",
	"buttonMLetterSpacing": "0",
	"buttonLSize": "20",
	"buttonLFamily": "\"JetSansDigital\"",
	"buttonLWeight": "700",
	"buttonLLetterSpacing": "0",
	"bodySSize": "14",
	"bodySFamily": "\"JetSansDigital\"",
	"bodySWeight": "400",
	"bodySParagraph": "14",
	"bodySLetterSpacing": "0",
	"bodySLinkSize": "14",
	"bodySLinkFamily": "\"JetSansDigital\"",
	"bodySLinkWeight": "400",
	"bodySLinkParagraph": "14",
	"bodySLinkLetterSpacing": "0",
	"bodySLinkTextDecoration": "underline",
	"bodyLSize": "16",
	"bodyLFamily": "\"JetSansDigital\"",
	"bodyLWeight": "400",
	"bodyLParagraph": "16",
	"bodyLLetterSpacing": "0",
	"bodyLLinkSize": "16",
	"bodyLLinkFamily": "\"JetSansDigital\"",
	"bodyLLinkWeight": "400",
	"bodyLLinkParagraph": "16",
	"bodyLLinkLetterSpacing": "0",
	"bodyLLinkTextDecoration": "underline",
	"bodyStrongSSize": "14",
	"bodyStrongSFamily": "\"JetSansDigital\"",
	"bodyStrongSWeight": "700",
	"bodyStrongSParagraph": "14",
	"bodyStrongSLetterSpacing": "0",
	"bodyStrongSLinkSize": "14",
	"bodyStrongSLinkFamily": "\"JetSansDigital\"",
	"bodyStrongSLinkWeight": "700",
	"bodyStrongSLinkParagraph": "14",
	"bodyStrongSLinkLetterSpacing": "0",
	"bodyStrongSLinkTextDecoration": "underline",
	"bodyStrongLSize": "16",
	"bodyStrongLFamily": "\"JetSansDigital\"",
	"bodyStrongLWeight": "700",
	"bodyStrongLParagraph": "16",
	"bodyStrongLLetterSpacing": "0",
	"bodyStrongLLinkSize": "16",
	"bodyStrongLLinkFamily": "\"JetSansDigital\"",
	"bodyStrongLLinkWeight": "700",
	"bodyStrongLLinkParagraph": "16",
	"bodyStrongLLinkLetterSpacing": "0",
	"bodyStrongLLinkTextDecoration": "underline",
	"captionSize": "12",
	"captionFamily": "\"JetSansDigital\"",
	"captionWeight": "400",
	"captionParagraph": "12",
	"captionLetterSpacing": "0",
	"captionLinkSize": "12",
	"captionLinkFamily": "\"JetSansDigital\"",
	"captionLinkWeight": "400",
	"captionLinkParagraph": "12",
	"captionLinkLetterSpacing": "0",
	"captionLinkTextDecoration": "underline",
	"captionStrongSize": "12",
	"captionStrongFamily": "\"JetSansDigital\"",
	"captionStrongWeight": "700",
	"captionStrongParagraph": "12",
	"captionStrongLetterSpacing": "0",
	"captionStrongLinkSize": "12",
	"captionStrongLinkFamily": "\"JetSansDigital\"",
	"captionStrongLinkWeight": "700",
	"captionStrongLinkParagraph": "12",
	"captionStrongLinkLetterSpacing": "0",
	"captionStrongLinkTextDecoration": "underline"
};
export default ___CSS_LOADER_EXPORT___;
